import ValidationError from '../common/ValidationError'

export default class DataFeed {
  enabled?: boolean
  reasonNotEnabled: string = ""
  editedByNT4Name: string = ""
  dateEdited?: Date
  validation: ValidationError[] = []
}
